class TwoWayMap<K, V>{
    map: Map<K, V>;
    reverseMap: Map<V, K>;

    get size() {
        return this.map.size;
    }

    constructor(map?: Map<K, V>) {
        this.map = map || new Map<K, V>();

        this.reverseMap = new Map<V, K>();
        for (const [key, value] of this.map) {
            this.reverseMap.set(value, key);
        }
    }

    set(key: K, value: V) {
        this.map.set(key, value);
        this.reverseMap.set(value, key);
    }

    has(key: K) {
        return this.map.has(key);
    }

    delete(key: K) {
        const value = this.map.get(key);
        this.map.delete(key);
        if (value) {
            this.reverseMap.delete(value);
        }
    }

    keyValues() {
        const keyValues: [any, any][] = [];
        for (const [key, value] of this.map) {
            keyValues.push([key, value]);
        }
        return keyValues;
    }

    get(key: K) {
        return this.map.get(key);
    }

    revGet(key: V) {
        return this.reverseMap.get(key);
    }
}

const makeTimeZoneTwoWayMap = () => {
    const timeZoneMap = new TwoWayMap<string, string>();

    timeZoneMap.set('Eastern Standard Time', 'Eastern');
    timeZoneMap.set('Central Standard Time', 'Central');
    timeZoneMap.set('US Mountain Standard Time', 'Arizona'); //Mountain (no DST)
    timeZoneMap.set('Mountain Standard Time', 'Mountain');
    timeZoneMap.set('Pacific Standard Time', 'Pacific');
    timeZoneMap.set('Alaskan Standard Time', 'Alaska');
    timeZoneMap.set('Aleutian Standard Time', 'Aleutian');
    timeZoneMap.set('Hawaiian Standard Time', 'Hawaii');

    return timeZoneMap;
}

export const timeZoneTupple = [
    { key: 'Eastern', id: 'Eastern Standard Time', displayName: 'Eastern Standard Time' },
    { key: 'Central', id: 'Central Standard Time', displayName: 'Central Standard Time' },
    { key: 'Arizona', id: 'US Mountain Standard Time', displayName: 'US Mountain Standard Time (Arizona)' },
    { key: 'Mountain', id: 'Mountain Standard Time', displayName: 'Mountain Standard Time' },
    { key: 'Pacific', id: 'Pacific Standard Time', displayName: 'Pacific Standard Time' },
    { key: 'Alaska', id: 'Alaskan Standard Time', displayName: 'Alaskan Standard Time' },
    { key: 'Aleutian', id: 'Aleutian Standard Time', displayName: 'Aleutian Standard Time' },
    { key: 'Hawaii', id: 'Hawaiian Standard Time', displayName: 'Hawaiian Standard Time' },
];
export const timeZoneStandardToDisplayMap = makeTimeZoneTwoWayMap();